import React from 'react';
import uniqueId from 'lodash/uniqueId';
import SkeletonElement from './SkeletonElement';

const DEFAULT_TEXT_SECTION_SKELETON_ROWS_COUNT = 5;

interface ITextSectionSkeleton {
  rowsCount? : number
}

const TextSectionSkeleton = ({
  rowsCount = DEFAULT_TEXT_SECTION_SKELETON_ROWS_COUNT,
}: ITextSectionSkeleton) => {
  const TextLines = [...Array(rowsCount)].map(() => <SkeletonElement key={uniqueId()} type="paragraph" />);

  return (
    <>
      <SkeletonElement type="label-short" />
      <br />
      {TextLines}
    </>
  );
};

export default TextSectionSkeleton;
